import VisitorDetailsStep from './VisitorDetailsStep';

export * from './types';

export default VisitorDetailsStep;
